import Vue from 'vue'
import Router from 'vue-router'
import util from '@/utils'
import store from '@/store'
import NProgress from 'nprogress' // nprogress插件


Vue.use(Router)

let whiteList = ['/login', '/register', '/forget', '/film'];

//解决路由堆叠问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [{
    path: '/',
    redirect: '/index/work/appointment'
  },
  {
    path: '/index',
    component: () =>
      import('@/views/index/layout.vue'),
    children: [{
      path: '/index/work',
      component: () =>
        import('@/views/work/work.vue'),
      children: [
        {
          path: '/index/work/patients',
          component: () =>
            import('@/views/work/children/patients.vue')
        },
        {
          path: '/index/work/appointment',
          component: () =>
            import('@/views/work/children/appointment.vue')
        }, {
          path: '/index/work/consultation',
          component: () =>
            import('@/views/work/children/consultation.vue')
        },

      ]
    },
    {
      path: '/index/work/slice',
      component: () => import('@/views/slice/index.vue')
    },
    {
      path: '/index/user',
      component: () =>
        import('@/views/users/user.vue'),
      children: [
        {
          path: '/index/user/patients',
          component: () =>
            import('@/views/users/children/patients.vue')
        },
        {
          path: '/index/user/auditInformation',
          component: () =>
            import('@/views/users/children/auditInformation/auditInformation.vue'),
            children: [
              {
                path: 'qualifications',
                component: () =>
                  import('@/views/users/children/auditInformation/children/qualifications.vue')
              },
              {
                path: 'information',
                component: () =>
                  import('@/views/users/children/auditInformation/children/information.vue')
              },
              {
                path: 'authentication',
                component: () =>
                  import('@/views/users/children/auditInformation/children/authentication.vue')
              },
              {
                path: 'auditInfo',
                component: () =>
                  import('@/views/users/children/auditInformation/children/auditInfo.vue')
              },
              {
                path:'',
                redirect:'information'
              }
            ]
        },
        {
          path: '/index/user/news',
          component: () =>
            import('@/views/users/children/news.vue')
        },
        {
          path: '/index/user/userInfo',
          component: () =>
            import('@/views/users/children/userInfo.vue')
        },
        {
          path: '/index/user/wallet',
          component: () =>
            import('@/views/users/children/wallet.vue'),
        },
        {
          path: '/index/user/wallet/cashLog',
          component: () =>
            import('@/views/users/children/cashLog.vue'),
        },
        {
          path: '/index/user/setup',
          component: () =>
            import('@/views/users/children/setup.vue')
        },
        {
          path: '/index/user/report',
          component: () =>
            import('@/views/users/children/report.vue')
        },
        {
          path: '/index/user/wallet/addCash',
          component: () =>
            import('@/views/users/children/addCash.vue')
        },
        {
          path: '/index/user/attendance',
          component: () =>
            import('@/views/users/children/attendance.vue')
        },
        {
          path: '/index/user/reportManage',
          component: () =>
            import('@/views/users/children/reportManage.vue')
        },
        {
          path: '/index/user/prescription',
          component: () =>
            import('@/views/users/children/prescription.vue')
        },
        {
          path: '/index/user/auditPrescription',
          component: () =>
            import('@/views/users/children/auditPrescription.vue')
        },
        {
          path: '/index/user/auditPrescription/prescriptionDetails',
          component: () =>
            import('@/views/users/children/prescriptionDetails.vue')
        },
        {
          path: '/index/user/prescription/prescriptionDetails',
          component: () =>
            import('@/views/users/children/prescriptionDetails.vue')
        },
      ]
    },
    {
      path: '/index/drug/index',
      name: 'Drug',
      component: () =>
        import('@/views/drug/index.vue')
    },
    {
      path: '/index/drugList/index',
      name: 'DrugList',
      component: () =>
        import('@/views/drugList/index.vue')
    },
    {
      path: '/index/work/workDetail',
      name: 'workDetail',
      component: () =>
        import('@/views/workDetail/index.vue')
    },
    {
      path: '/index/work/patientDetails',
      name: 'patientDetails',
      component: () =>
        import('@/views/workDetail/children/patientDetails.vue')
    },
    {
      path: '/index/work/appointmentList',
      component: () =>
        import('@/views/work/children/appointmentList.vue')
    },
    {
      path: '/index/work/chart',
      name: 'chart',
      component: () =>
        import('@/views/chart/index.vue')
    },

    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import('@/views/login/index.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () =>
      import('@/views/register/index.vue')
  },
  {
    path: '/forget',
    name: 'forget',
    component: () =>
      import('@/views/forget/index.vue')
  },
  {
    path: '/lock',
    name: 'lock',
    component: () =>
      import('@/components/common/lock.vue')
  },
  {
    path: '/film',
    name: 'film',
    component: () =>
      import('@/components/common/film.vue')
  },
  ]
})
router.beforeEach((to, form, next) => {
  let user_token = util.getStore('user_token');
  let lockState = util.getStore('lockState');
  let toPath = to.path
  document.body.scrollTop = 0
  // firefox 
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0

  if (whiteList.indexOf(toPath) == -1 && (!user_token && user_token !== 'undefined' && user_token != 'null')) {
    //不在白名单，并且user_token没有
    router.push({
      path: '/login'
    })
    next();　　//这行是重点，解决登录后不能回退页面bug的原因就在这
    //开始进度条
    // NProgress.start();
  } else if (whiteList.indexOf(toPath) != -1) {
    //去登录页
    util.removeStore('user_token')
    //开始进度条
    // NProgress.start();
    next();
  } else if (whiteList.indexOf(toPath) == -1 && user_token) {
    //开始进度条
    NProgress.start();
    next()
  }

  /**
   * 判断锁屏
   */
  if (lockState === '0' && to.path !== '/lock') {
    router.push({
      path: '/lock'
    })
  }
});
router.afterEach(transition => {
  //结束进度条
  NProgress.done();
});
export default router;
